module.exports = __webpack_public_path__ + "img/slide-8-5.05225a20.jpg";